import $ from 'jquery';


class FooterSelector {

	constructor() {
		if ($("#footer_selector").length> 0) {
			this.init();
		}
	}

	init() {

		Vue.component('footer-selector', () => import('../components/FooterSelector.vue'));


			window.footer_selector_vm = new Vue({
				el: '#footer_selector',
				data: {
					lang: window.selected_lang,
				},
				methods: {
					upd(lang) {
						this.lang = lang;
					}
				}
			});
			


	}


}

export default FooterSelector;
